/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Confirmation_EmailInputs */

const en_consumer_declaration_confirmation_email = /** @type {(inputs: Consumer_Declaration_Confirmation_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmation email`)
};

const de_consumer_declaration_confirmation_email = /** @type {(inputs: Consumer_Declaration_Confirmation_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail für die Eingangsbestätigung`)
};

const fr_consumer_declaration_confirmation_email = /** @type {(inputs: Consumer_Declaration_Confirmation_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail de confirmation`)
};

const es_consumer_declaration_confirmation_email = /** @type {(inputs: Consumer_Declaration_Confirmation_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo de confirmación`)
};

const it_consumer_declaration_confirmation_email = /** @type {(inputs: Consumer_Declaration_Confirmation_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail di conferma`)
};

const nl_consumer_declaration_confirmation_email = /** @type {(inputs: Consumer_Declaration_Confirmation_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail voor bevestiging`)
};

const pl_consumer_declaration_confirmation_email = /** @type {(inputs: Consumer_Declaration_Confirmation_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail potwierdzenia`)
};

const fi_consumer_declaration_confirmation_email = /** @type {(inputs: Consumer_Declaration_Confirmation_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvistussähköposti`)
};

const da_consumer_declaration_confirmation_email = /** @type {(inputs: Consumer_Declaration_Confirmation_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail til bekræftelse`)
};

const sv_consumer_declaration_confirmation_email = /** @type {(inputs: Consumer_Declaration_Confirmation_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post för bekräftelse`)
};

/**
* | output |
* | --- |
* | "Confirmation email" |
*
* @param {Consumer_Declaration_Confirmation_EmailInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_confirmation_email = /** @type {((inputs?: Consumer_Declaration_Confirmation_EmailInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Confirmation_EmailInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_confirmation_email(inputs)
	if (locale === "fr") return fr_consumer_declaration_confirmation_email(inputs)
	if (locale === "es") return es_consumer_declaration_confirmation_email(inputs)
	if (locale === "it") return it_consumer_declaration_confirmation_email(inputs)
	if (locale === "nl") return nl_consumer_declaration_confirmation_email(inputs)
	if (locale === "pl") return pl_consumer_declaration_confirmation_email(inputs)
	if (locale === "fi") return fi_consumer_declaration_confirmation_email(inputs)
	if (locale === "da") return da_consumer_declaration_confirmation_email(inputs)
	if (locale === "sv") return sv_consumer_declaration_confirmation_email(inputs)
	return en_consumer_declaration_confirmation_email(inputs)
});